import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import Button from "../../components/common/Button";
import { getPatronatInfoByName } from "../../backend/info/patronatInfo";
import formatPhoneNumber from "../../utils/formatNumber";
import { Helmet } from "react-helmet-async";

const PhoneButton = ({ link, text }) => {
  const isBigSingle = useMediaQuery({ query: `(max-width: 1300px)` });
  return (
    <Button
      text={text}
      external_link={link}
      border="3px solid var(--black)"
      hoverBorder="3px solid var(--white)"
      textColor="var(--black)"
      hoverTextColor="var(--white)"
      fontWeight="bold"
      fontSize={isBigSingle ? "min(2.5rem, 9vw)" : "clamp(2.5rem, 3.2vw, 4rem)"}
      padding="1rem 1rem"
      iconPath="/assets/icons/tel.svg"
      iconProps={{
        width: "min(2.5rem,10vw)",
        height: "min(2.5rem,10vw)",
        marginRight: "0.5rem",
      }}
      iconColor="var(--black)"
      hoverIconColor="var(--white)"
    />
  );
};

const SupportService = () => {
  const isMedium = useMediaQuery({ query: `(max-width: 600px)` });
  const isSmall = useMediaQuery({ query: `(max-width: 600px)` });
  const [imageOffeset, setImageOffset] = useState("0px");
  const showBigLogo = useMediaQuery({ query: `(min-width: 1100px)` });
  const isBigSingle = useMediaQuery({ query: `(max-width: 1300px)` });
  const isButtonFullLength = useMediaQuery({ query: `(max-width: 900px)` });

  useEffect(() => {
    setTimeout(() => {
      setImageOffset("0px");
    }, 100);
  }, []);

  const [scrollY, setScrollY] = useState(0);

  function handleScroll() {
    setScrollY(window.scrollY);
  }

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [scrollY]);

  return (
    <div style={styles.supportWrapper}>
      <Helmet>
        <title>{getPatronatInfoByName("title")}</title>
        <meta name="description" content={getPatronatInfoByName("description")} />
        <meta property="og:title" content={getPatronatInfoByName("title")} />
        <meta property="og:description" content={getPatronatInfoByName("description")} />
      </Helmet>
      <div style={styles.supportContainer}>
        <div
          style={{
            ...styles.infoColumn,
            paddingTop: showBigLogo ? "5rem" : isMedium ? "2rem " : "4rem",
            paddingBottom: showBigLogo ? "5rem" : isMedium ? "2rem " : "4rem",
          }}
        >
          {isMedium && <p style={{ fontSize: "2rem", margin: "1rem 0rem" }}>210 ОШП</p>}
          <h1
            style={{
              ...styles.header,
              fontSize: showBigLogo
                ? "clamp(1rem, 4vw, 5rem)"
                : isMedium
                  ? "clamp(1rem, 13vw, 5rem)"
                  : "clamp(1rem, 7vw, 4rem)",
              marginBottom: isSmall ? "2  rem" : isMedium ? "2rem" : "3rem",
              overflowWrap: "break-word",
              maxWidth: showBigLogo ? "calc(var(--main-container-width)/1.5)" : "90vw",
            }}
          >
            {isMedium ? getPatronatInfoByName("h1mobile") : getPatronatInfoByName("h1")}
          </h1>

          <div
            style={{
              ...styles.phoneContainer,
              flexDirection: isBigSingle ? "column" : "row",
              alignSelf: showBigLogo ? "start" : "center",
              width: isButtonFullLength ? "100%" : "",
              marginBottom: isSmall ? "2rem" : isMedium ? "2rem" : "3rem",
              gap: "2rem",
            }}
          >
            <PhoneButton
              link={formatPhoneNumber(getPatronatInfoByName("phone1"))}
              text={getPatronatInfoByName("phone1")}
            />
            <PhoneButton
              link={formatPhoneNumber(getPatronatInfoByName("phone2"))}
              text={getPatronatInfoByName("phone2")}
            />
          </div>

          <h2
            style={{
              ...styles.slogan,
              fontSize: isMedium ? "min(2.5rem, 10vw)" : "clamp(2rem, 3.5vw, 4.5rem)",
              marginBottom: isSmall ? "2rem" : isMedium ? "2rem" : "3rem",
              overflowWrap: "break-word",
            }}
          >
            {getPatronatInfoByName("h2")}
          </h2>

          <p
            style={{
              ...styles.description,
              maxWidth: showBigLogo ? "calc(var(--main-container-width) * 0.8)" : "",
            }}
          >
            Місія служби — бути опорою для тих, хто боронить Україну, і підтримкою для їхніх
            близьких у найважчі моменти життя
          </p>
        </div>

        {showBigLogo && (
          <div style={styles.logoContainer}>
            <img src="assets/icons/210-logo-big.svg" alt={"Big logo"} style={styles.logoStyle} />
          </div>
        )}
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  supportWrapper: {
    display: "flex",
    width: "100%",
    backgroundColor: "var(--olive)",
    overflow: "hidden",
  },
  supportContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    width: "var(--main-container-width)",
    margin: "0 auto",
  },
  infoColumn: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  logoContainer: {
    position: "absolute",
    top: "var(--header-height)",
    left: 0,
    width: "100%",
    overflow: "hidden",
    pointerEvents: "none",
  },
  logoStyle: {
    position: "relative",
    left: "calc(100vw - var(--main-container-margin))",
    height: "calc(44rem + clamp(0rem, 3.5vw, 7rem)",
    transform: "translateX(-65%)",
  },
  header: {
    color: "var(--black)",
    margin: "0 0 2rem 0",
    fontWeight: "normal",
  },
  phoneContainer: {
    display: "flex",
    flexWrap: "wrap",
  },
  slogan: {
    fontSize: "3rem",
    fontWeight: "500",
    color: "var(--black)",
  },
  description: {
    fontSize: "2rem",
    color: "var(--black)",
    margin: "0",
  },
};

export default SupportService;
